import { render, staticRenderFns } from "./CloseOfDay.vue?vue&type=template&id=4b5b66ae&"
import script from "./CloseOfDay.vue?vue&type=script&lang=js&"
export * from "./CloseOfDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports